export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          有任何关于刃牙漫画的问题、建议或投稿意向，欢迎通过以下方式联系
        </p>
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-600">submission@baki-manga.example.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-chat-3-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">读者反馈</h3>
              <p className="text-xs text-foreground-600">feedback@baki-manga.example.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-team-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600">biz@baki-manga.example.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}